const { default: Loadable } = require("app/components/Loadable");
const { lazy } = require("react");

  
  const Subscriptionfile = Loadable(lazy(()=>import("./Subscriptionfile")))

 const Subscription=Loadable(lazy(()=>import("./Subscription")))
 const SubscriptionChoosed=Loadable(lazy(()=>import("./SubscriptionChoosed")));
 const SubscriptionPlanChoosed=Loadable(lazy(()=>import("./subscriptionplanChoosed")));
 const PaymentScreen=Loadable(lazy(()=>import("./Paymentscreen")));
 const ContactSupport = Loadable(lazy(()=>import("./contactSupport")));

  const SubscriptionRoutes = [
   { path: '/subscription/upgrade-plan/:mode/:id', element: <Subscription /> },
      { path: '/subscription', element: <Subscriptionfile /> },

{ path: '/subscription/plan-choosed', element: <SubscriptionChoosed /> },
{ path: '/subscription/plan-choosed/fixed', element: <SubscriptionPlanChoosed /> },
{ path: '/subscription/plan-choosed/payment', element: <PaymentScreen /> },
{ path: '/subscription/contactSupport', element: <ContactSupport /> },



];

export default SubscriptionRoutes;